export default ({ children, visible }) => {
  if (!visible) return null;
  return children || null
}
